import * as R from 'remeda';
import { Prettify } from '../../lib/typeUtils';

// TODO: It's a bit weird that this would sit inside `/features` but it's the only way to keep it all together
// and get good types
export const allFeaturesList = [
  {
    id: 'integration-test-flag',
    type: 'internal',
    description: 'Feature flag used in integration tests',
    owner: 'Jan Pfajfr',
  } as const,
  {
    id: 'send-metrics-to-prometheus',
    type: 'internal',
    description: 'Feature flag used for sending FE telemetry to Prometheus',
    owner: 'Jan Pfajfr',
  } as const,
  {
    id: 'ac-661-survey',
    type: 'internal',
    description: 'Enables onboarding survey',
    epic: 'AC-661',
    owner: 'Jozef Skripko',
  } as const,
  {
    id: 'ac-494-billing',
    type: 'internal',
    description: 'Billing',
    epic: 'AC-494',
    owner: 'Jozef Skripko',
  } as const,
  {
    id: 'ac-1483-bulk-download-original-files',
    type: 'internal',
    description:
      'Enables bulk download of original files on documents dashboards',
    epic: 'AC-1483',
    owner: 'Martin Brodziansky',
  } as const,
  {
    id: 'ac-4336-confidence-indicator',
    type: 'internal',
    description:
      'Enables confidence score indicators on extracted fields on new dashboard',
    owner: 'Martin Brodziansky',
  } as const,
  {
    id: 'ac-4343-forrester-demo-custom-document-type',
    type: 'internal',
    description: 'Enables custom document type template when creating queue',
    owner: 'Ondrej Matejka',
  } as const,
  {
    id: 'ac-4438-popup-for-trusted-buttons',
    type: 'internal',
    description: 'Enables sharing token with 3rd party apps via buttons.',
    epic: 'AC-4438',
    owner: 'Pavel Sury',
  } as const,
  {
    id: 'ac-4198-field-manager-improvements',
    type: 'internal',
    description:
      'Enables duplicate, copy and bulk operations on field and improving filtering and user experience',
    epic: 'AC-4198',
    owner: 'Jan Pfajfr',
  } as const,
  {
    id: 'ac-5730-fe-exe-interop',
    type: 'internal',
    description:
      'Enables rossum commands (and using events in extension responses)',
    epic: 'AC-5730',
    owner: 'Pavel Sury',
  } as const,
  {
    id: 'xmas',
    type: 'internal',
    description: 'Enables Xmas mode',
    epic: '-',
    owner: 'Martin Brodziansky',
  } as const,
  {
    id: 'aggressive-dashboard-refetching',
    type: 'internal',
    description:
      'Enables aggressive refetching of dashboard data from `/search` after a document is imported',
    epic: '-',
    owner: 'Martin Brodziansky',
  } as const,
  {
    id: 'smartlook-percentage-rollout',
    type: 'internal',
    description:
      'Used to limit smartlook initialization by percent rollout strategy',
    epic: '-',
    owner: 'Jan Pfajfr',
  } as const,
  {
    id: 'smartlook-whitelist',
    type: 'internal',
    description: 'Used to enables smartlook for specific organization',
    epic: '-',
    owner: 'Jan Pfajfr',
  } as const,
  {
    id: 'hypercare-metrics',
    type: 'internal',
    description:
      'Used to enables metrics with labels for specific organization',
    epic: '-',
    owner: 'Jan Pfajfr',
  } as const,
];

type BaseFeature = {
  id: FeatureId;
  type: 'internal' | 'lab';
  description: string;
  owner?: string;
  epic?: string;
};

export type InternalFeature = Prettify<
  BaseFeature & {
    type: 'internal';
  }
>;

export const isInternalFeature = (
  feature: Feature
): feature is InternalFeature => feature.type === 'internal';

export type LabFeature = Prettify<
  BaseFeature & {
    type: 'lab';
    name: string;
    gaDate: string;
  }
>;

export const isLabFeature = (feature: Feature): feature is LabFeature =>
  feature.type === 'lab';

export type Feature = InternalFeature | LabFeature;

export const allFeatures = R.indexBy(allFeaturesList, ({ id }) => id);

export type FeatureId = (typeof allFeaturesList)[number]['id'];

export const labFeaturesList = R.pipe(allFeaturesList, R.filter(isLabFeature));

export const labFeatures = R.pipe(
  labFeaturesList,
  R.indexBy(({ id }) => id)
);

export const internalFeaturesList = R.pipe(
  allFeaturesList,
  R.filter(isInternalFeature)
);

export const internalFeatures = R.pipe(
  internalFeaturesList,
  R.indexBy(({ id }) => id)
);
